// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const TRANSLATE_ANTIBODY_COMPONENT_DNA_TO_AA_STEP_SHAPES = [
  {
    stepType: PipelineStepType.TRANSLATE_ANTIBODY_COMPONENT_DNA_TO_AA,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input file': {
        systemName: 'Input file',
        displayName: 'Input file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output file': {
        systemName: 'Output file',
        displayName: 'Output file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    config: {}
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
